import { LoadProfile, UpdateProfile, UploadAvatar } from './profile.actions';

export const ProfileLoadingActions = [LoadProfile, UpdateProfile, UploadAvatar];
